module.exports = __webpack_public_path__ + "static/media/freelancer-vs-agency.a08bb25d.svg";